<template>
	<VanPopup
		:value="isShow"
		round
		safe-area-inset-bottom
		position="bottom"
		overlay-class="custom-van-popup-overlay"
		class="custom-van-popup"
		@click-overlay="onClickOverlay"
	>	
		<div class="order-cancel-view">
			<div class="bg"></div>
			<div class="reasons" v-show="!submitted">
				<div class="title">取消行程原因</div>
				<div class="header">您为什么取消？选择原因，我们会全力改善体验～</div>
				<div class="reason" v-for="(item, index) in reasons" :key="index">
					<div class="subtitle" v-if="item.type !== 'other'">{{item.title}}</div>
					<template v-if="item.children && item.children.length">          
						<div class="row" v-for="(child, index2) in item.children" :key="index2">
							<div class="label">{{child.label}}</div>
							<img v-if="child.id === activeId" src="../../assets/img-v2/ic_order_cancel_radio_selected.png" class="radio" />
							<img v-else src="../../assets/img-v2/ic_order_cancel_radio.png" class="radio" @click="onCheck(child.id)" />
						</div>
					</template>
					<!-- 其它 -->
					<template v-else>
						<div class="subtitle">
							<div>{{item.title}}</div>
							<img v-if="item.id === activeId" src="../../assets/img-v2/ic_order_cancel_radio_selected.png" class="radio" />
							<img v-else src="../../assets/img-v2/ic_order_cancel_radio.png" class="radio" @click="onCheck(item.id)" />
						</div>
					</template>
					<div v-if="item.type === 'other' && inputVisible">
						 <textarea class="reason-input" v-model="inputValue" placeholder="请填写原因"></textarea>
						<VanButton class="reason-submit" :disabled="submitting" @click="submit(item)">提交</VanButton>
					</div>
				</div>
			</div>
		</div>
	</VanPopup>
</template>
<script>
import {wait} from "../../utils";
const reasons = [
  {
    title: '车辆问题',
    type: 'category',
    children: [
      {
        id: 1,
        label: '没有显示车辆位置',
      },
      {
        id: 2,
        label: '车离我越来越远',
      },
      {
        id: 3,
        label: '在车站找不到车辆',
      },
    ]
  },
  {
    title: '自己原因',
    type: 'category',
    children: [
      {
        id: 4,
        label: '行程有变，不需要用车',
      },
      {
        id: 5,
        label: '赶时间，不想等了',
      },
      {
        id: 6,
        label: '下错单/选错站',
      },
      {
        id: 7,
        label: '找不到上车站',
      },
    ]
  },
  {
		title: '其他',
		id: '8',
    type: 'other'
	}
];
let submitToast;
export default {
	name: 'OrderCancelView',
	data() {
		return {
			isShow: false,
			reasons,
			inputVisible: false,
			submitting: false,
			activeId: -1,
			inputValue: '',
			submitted: false
		};
	},
	computed: {
		ticketInfoId() {
			return this.$route.query.ticketInfoId || this.$AppService.getTicketInfoId();
		}
	},
	watch: {
		submitting(submitting) {
			if (!submitToast) {
				submitToast = this.$createToast({
					type: 'loading',
					text: '提交中...'
				});
			}
			if (submitting) {
				submitToast.show();
			} else {
				submitToast.hide();
			}
		}
	},
	activated() {
		this.isShow = true;
		this.submitting = false;
		this.submitted = false;
		this.activeId = -1;
		this.inputValue = '';
		this.inputVisible = false;
	},
	methods: {
		onCheck(id) {
			this.activeId = id;
			const target = reasons.find(item => item.id === id && id)
			const isOther = target && target.type === 'other';
			if (isOther) {
				this.inputVisible = true;
			} else {
				this.inputVisible = false;
				reasons.forEach(item => {
					const children = item.children;
					if (children) {
						children.forEach(child => {
							if (child.id === id) {
								this.submit({label: child.label})
								return
							}
						})
					}
				})
			}
		},
		submit(reason) {
			let {type, label} = reason;
      if (type === 'other') {
        if (!this.inputValue.trim()) {
          this.$toast('请填写原因');
          return;
        }
        this.report('其他:'+this.inputValue);
      } else {
				this.report(label);

      }
		},
		report(refundReason) {
			if (!refundReason) {
				this.$toast('请填写原因');
				return;
			}
			this.submitting = true;
			this.$OrderService.reportCancelReason(this.ticketInfoId, refundReason).then(() => {
				this.afterReport();
			}).catch(() => {
				this.afterReport();
			});
		},
		goback() {
			if (window.history.length > 1) {
				this.$router.back();
			} else {
				this.$HomeService.turnToHomeView();
			}
		},
		afterReport() {
			this.submitting = false;
			this.$toast({
				message: '提交成功',
				duration: 1000
			});
			wait(1000).then(() => {
				this.goback();
			});
		},
		onClickOverlay() {
			this.isShow = false;
			this.goback();
		}
	}
}
</script>

<style scoped lang="scss">
	.order-cancel-view {
		padding-bottom: calc(20px + constant(safe-area-inset-bottom));
		padding-bottom: calc(20px + env(safe-area-inset-bottom));
		position: relative;
		.bg {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 200px;
			background: linear-gradient( 180deg, #BDDEFF 0%, #FFFFFF 100%), linear-gradient( 226deg, #D9FFF3 0%, rgba(255,255,255,0) 100%);
		}
		.reasons {
			position: relative;
			padding: 0 20px;

			.title {
				height: 60px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				line-height: 22px;
			}
      .header {
				height: 40px;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 12px;
				color: rgba(0,0,0,0.7);
				line-height: 17px;
      }

			.reason {
			}

      .subtitle {
				height: 40px;
        display: flex;
				justify-content: space-between;
        align-items: center;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #000000;
				line-height: 20px;
      }

			.row {
				height: 40px;
        display: flex;
				justify-content: space-between;
        align-items: center;
			}
			.label {
				flex: 1;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: rgba(0,0,0,0.7);
				line-height: 18px;
			}
			.radio {
				width: 16px;
				height: 16px;
			}
			.reason-input {
				width: 100%;
				height: 80px;
				border-radius: 8px;
				border: 1px solid #EEEEEE;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				line-height: 20px;
				padding: 10px;
				-webkit-appearance: none;
				appearance: none;
				box-shadow: none;
				&::placeholder {
					color: rgba(0,0,0,0.4);
				}
			}
			.reason-submit {
				width: 100%;
				height: 48px;
				background: #006EFA;
				border-radius: 25px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 22px;
				margin: 20px 0;
			}
		}
	}
</style>
